import request from '@/utils/http';

// [操作指南管理页面]-查询接口
export const guideSearch = (params) => {
    return request({
        url: '/api-sn/config/guideManage/searchPage',
        method: 'post',
        data: params
    });
};

// [操作指南管理页面]-删除接口
export const guideDelete = (id) => {
    return request({
        url: `/api-sn/config/guideManage/delete/${id}`,
        method: 'get'
    });
};

// [操作指南管理页面]-新增接口
export const guideAdd = (params) => {
    return request({
        url: '/api-sn/config/guideManage/save',
        method: 'POST',
        data: params
    });
};

// [操作指南管理页面]-修改接口
export const editAdd = (params) => {
    return request({
        url: '/api-sn/config/guideManage/update',
        method: 'POST',
        data: params
    });
};

// [操作指南管理页面]-状态更改接口
export const editStatus = (params) => {
    return request({
        url: `/api-sn/config/guideManage/status?id=${params.id}&status=${params.status}`,
        method: 'get'
    });
};